import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import store from '../store/Store';
import { isIOS } from '@uifabric/utilities';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

export const isMeControlEnabled = () => isMiniHostAppFeatureEnabled('miniMeControl');

export const isSingleAccount = () => {
    //checks if the user has a single account logged in
    return store.rememberedAccountsLength === 1;
};

export const isGmailReferralFromMeControlEnabled = () =>
    isMiniFeatureEnabled('mini-me-control-referral') && !isIOS() && isConsumer();
